import { render } from "./OverallResult.vue?vue&type=template&id=1873d35e&ts=true"
import script from "./OverallResult.vue?vue&type=script&lang=ts"
export * from "./OverallResult.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__